import { profileAPI } from "@/lib/api/api";
import { PROFILE_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

type ProfileSection =
  | "awardSection"
  | "courseAndCertificationSection"
  | "educationDetailSection"
  | "employmentDetailSection"
  | "jobPreferenceSection"
  | "languageSection"
  | "manageProfileSection"
  | "personalDetailSection"
  | "projectDetailSection"
  | "resumeSection"
  | "skillSection"
  | "socialPresenceSection"
  | "workSampleSection";

export const useProfileData = () => {
  return useQuery({
    queryKey: [PROFILE_QUERY_KEY],
    queryFn: () =>
      profileAPI<any>(
        "personal_details,awards,courses_and_certifications,educations,job_preferences,additional_profiles,projects,resumes,employments,languages,skills_and_it_skills,social_presence,work_sample",
      ),
  });
};

type ProfileSectionResult<T> = Omit<UseQueryResult<T, Error>, "data"> & {
  data: T | undefined;
  workAuthChangeRequired?: boolean;
};

export const useProfileSectionData = <T>(
  section: ProfileSection,
): ProfileSectionResult<T> => {
  const query = useProfileData();

  if (section === "personalDetailSection") {
    return {
      ...query,
      data: query.data
        ? ({ [section]: query.data?.[section] } as T)
        : undefined,
      workAuthChangeRequired: query.data?.workAuthChangeRequired ?? false,
    };
  }

  return {
    ...query,
    data: query.data ? ({ [section]: query.data?.[section] } as T) : undefined,
  };
};
